// @ts-strict-ignore
import { forwardRef, Inject, Injectable, ViewContainerRef } from '@angular/core';
import { Observable } from 'rxjs';
import {
  LMActionFormDialogComponent,
  LMActionFormDialogResult,
  LMActionFormDialogService
} from '@modal/index';
import { LMTransactionState } from '@transaction/lm-transaction-state';
import { LMModalDialogWrapperRef } from '@app/services';

@Injectable()
export class LMListActionFormDialogService {
  constructor(
    @Inject(forwardRef(() => LMActionFormDialogService)) private lmActionFormDialogService, // LMActionFormDialogService,
  ) {
  }

  public get hasOpenDialog(): boolean {
    return this.lmActionFormDialogService.hasOpenDialog;
  }

  public get getOpenDialog(): LMModalDialogWrapperRef<LMActionFormDialogComponent> {
    return this.lmActionFormDialogService.getOpenDialog;
  }

  // deprecate this
  public getActionFormDialogDataView(formDataUrl: string): Observable<LMDataView> {
    // fronts for LMActionFormDialogService.getActionFormDialogDataView
    return this.lmActionFormDialogService.getActionFormDialogDataView(formDataUrl);
  }

  // deprecate this
  public runActionFormDialog(
    formUrlInfo: LMFormUrlInfo,
    formSpec: LMFormSpec,
    dataView: LMDataView,
    actionSpec: LMActionSpec,
    placeholder: ViewContainerRef,
    transactionState?: LMTransactionState
  ): Observable<LMActionFormDialogResult> {
    return this.lmActionFormDialogService.runActionFormDialog(formUrlInfo, formSpec, actionSpec, dataView, transactionState);
  }
}
